import { Pipe, PipeTransform } from '@angular/core';
import { DateTime } from 'typescript-dotnet-es6/System/Time/DateTime'

@Pipe({
  name: 'dateTimeTime'
})
export class DateTimeTimePipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if(value)
      return value.toJsDate().toLocaleTimeString();
    return '';
  }

}
